import { client } from '../utils'
import { OBJECT_ID } from './urls'
import { badges as endpoints } from '../api_urls'

export const getBadgeInfo = () => {
  return async dispatch => {
    let url = endpoints.show({ id: OBJECT_ID })
    try {
      var response = await client.get(url)
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
      return
    }
    dispatch(updateBadgeInfo({ ...response.data, retrievedEditData: true }))
  }
}

export const getAssessmentsJson = () => {
  return async dispatch => {
    let url = endpoints.assessments()
    try {
      var response = await client.get(url)
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
      return
    }
    dispatch(updateAssessments(response.data))
  }
}

export const getChaptersJson = () => {
  return async dispatch => {
    let url = endpoints.chapters()
    try {
      var response = await client.get(url)
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
      return
    }
    dispatch(updateChapters(response.data))
  }
}

export const getVideosJson = () => {
  return async dispatch => {
    let url = endpoints.videos()
    try {
      var response = await client.get(url)
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
      return
    }
    dispatch(updateVideos(response.data))
  }
}

export const createBadge = badgeInfo => {
  return async dispatch => {
    let url = endpoints.create()
    try {
      var response = await client.post(url, { badgeInfo })
    } catch (err) {
      console.error('Error creating badge', err)
      if (err.message === 'Network Error') {
        dispatch(setErrors([err.message + ', icon file(s) may be too large']))
      } else {
        dispatch(setErrors([err.message]))
      }
      return
    }
    dispatch(finishBadge(response.data.badge.id))
  }
}

export const updateBadge = badgeInfo => {
  return async dispatch => {
    let url = endpoints.update({ id: OBJECT_ID })
    try {
      var response = await client.put(url, { badgeInfo })
    } catch (err) {
      console.error('Error creating badge', err)
      if (err.message === 'Network Error') {
        dispatch(setErrors([err.message + ', icon file(s) may be too large']))
      } else {
        dispatch(setErrors([err.message]))
      }
      return
    }
    dispatch(finishBadge(response.data.badge.id))
  }
}

export const updateBadgeInfo = badgeInfo => {
  return {
    type: 'UPDATE_BADGE_INFO',
    badgeInfo,
  }
}

export const updateAssessments = assessments => {
  return {
    type: 'UPDATE_ASSESSMENTS',
    assessments,
  }
}

export const updateChapters = chapters => {
  return {
    type: 'UPDATE_CHAPTERS',
    chapters,
  }
}

export const updateVideos = videos => {
  return {
    type: 'UPDATE_VIDEOS',
    videos,
  }
}

export const pushAssessments = selectedAssessments => {
  return {
    type: 'PUSH_ASSESSMENTS',
    selectedAssessments,
  }
}

export const pushChapters = selectedChapters => {
  return {
    type: 'PUSH_CHAPTERS',
    selectedChapters,
  }
}

export const pushVideos = selectedVideos => {
  return {
    type: 'PUSH_VIDEOS',
    selectedVideos,
  }
}

export const pushPassingScore = passingScore => {
  return {
    type: 'PUSH_PASSING_SCORE',
    passingScore,
  }
}

export const finishBadge = badgeId => {
  return {
    type: 'FINISH_BADGE',
    badgeId,
  }
}

export const setErrors = errors => {
  return {
    type: 'SET_ERRORS',
    errors,
  }
}
